import { DateRangePicker, DateRangePickerProps } from '@tunglt91/react-nice-dates/build/index.esm.js';
import '@tunglt91/react-nice-dates/build/style.css';
import { format } from 'date-fns';
import { enGB } from 'date-fns/locale';
import React from 'react';

import './DateRangePicker.css';

export type CustomDateRangePickerValue = {
	startDate: DateRangePickerProps['startDate'];
	endDate: DateRangePickerProps['endDate'];
};

const CustomDateRangePicker = ({
	id,
	value,
	onChange,
	dateFormat = 'dd/MM/yyyy',
}: {
	id?: string;
	value: CustomDateRangePickerValue;
	onChange?: (props: CustomDateRangePickerValue) => void;
	dateFormat?: string;
}) => {
	const { startDate, endDate } = value;
	return (
		<DateRangePicker
			startDate={startDate}
			endDate={endDate}
			onStartDateChange={(date) => {
				if (date) {
					onChange({ startDate: date, endDate });
				}
			}}
			onEndDateChange={(date) => {
				if (date) {
					onChange({ startDate, endDate: date });
				}
			}}
			minimumLength={1}
			locale={enGB}
			format={dateFormat}
		>
			{({ startDateInputProps, endDateInputProps }) => {
				return (
					<div className="flex flex-row gap-2">
						<input
							{...startDateInputProps}
							value={startDateInputProps.value ? startDateInputProps.value : format(startDate, dateFormat)}
							placeholder="Start date"
							id={`${id}-start-date`}
						/>
						<input
							{...endDateInputProps}
							value={endDateInputProps.value ? endDateInputProps.value : format(endDate, dateFormat)}
							placeholder="End date"
							id={`${id}-end-date`}
						/>
					</div>
				);
			}}
		</DateRangePicker>
	);
};

export default CustomDateRangePicker;
